import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { createTmpUploadedImgs } from '../handler/ChatAIHandler';

export default function ImageCapture({
    corporationDetail,
    projectInuseDetail,
    chatThreadId,
    setUploadImgs,
    setIsUploading,
    validateUploadImages = () => {}
}) {
    const inputRef = useRef(null);

    const handleFileChange = e => {
        const file = e.target.files[0];
        if (file) {
            const isValidImgs = validateUploadImages([file]);
            if (!isValidImgs) return;

            // onCapture && onCapture(file);
            const img = {
                id: `tmp_attach_${uuidv4()}`,
                localUrl: URL.createObjectURL(file),
                fileData: file
            };
            setUploadImgs(prev => [...prev, img]);
            createTmpUploadedImgs(
                corporationDetail.id,
                projectInuseDetail.id,
                chatThreadId,
                [img],
                setUploadImgs,
                setIsUploading
            );
        }
    };

    return (
        <div>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            <button
				className="btn-reset-default ai-chat-input-btn"
				onClick={() => inputRef.current.click()}
			>
                <CameraAltIcon />
            </button>
        </div>
    );
}

ImageCapture.propTypes = {
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    chatThreadId: PropTypes.string,
    setUploadImgs: PropTypes.array,
    validateUploadImages: PropTypes.func,
};
